import React, { PropsWithChildren } from 'react'
import { toast } from 'react-toastify'
import { Me } from 'service/user'
import { ReactComponent as CopyIcon } from 'svg/copy.svg'
import { ReactComponent as ExternalIcon } from 'svg/fi_external-link.svg'
import { ReactComponent as HelpIcon } from 'svg/fi_help-circle.svg'
import { UserType } from 'utils/common'
import { useTranslation } from '../../hooks/useTranslation'

interface FastclickDescriptionProps {
  userInfo: Me
}

export const FastclickDescription = ({
  userInfo,
}: PropsWithChildren<FastclickDescriptionProps>) => {
  const { t } = useTranslation()
  const moveToUrl = (url: string) => {
    if (url) {
      window.open(url)
    }
  }

  const handleCopyClipBoard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text)
      toast.success(t('fastclick.copyComplete'), {
        position: 'bottom-center',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      })
    } catch (e) {}
  }
  return (
    <>
      {' '}
      <div className=" bg-gradient-to-r from-[#FF1E5E] to-[#FF8A00] md:p-8 p-4 flex flex-col md:rounded-[40px] gap-2">
        <div>
          <p className="flex gap-2 items-center">
            <span>
              <img src="assets/img/logo/fastclick_white.png" alt="fastclick" />
            </span>
            <span className="text-white font-[900] ">{t('fastclick.title')}</span>
            <span className="text-white font-bold  text-[14px] ">
              {t('fastclick.subtitle')}
            </span>
          </p>
          <p className=" font-bold text-white mt-2">{t('fastclick.whatIsFastclick')}</p>
          <p className="text-white">
            {t('fastclick.description')}
            <br /> <span className="font-bold">{t('fastclick.linkService')}</span>
            <br /> {t('fastclick.description2')}
            <br />
            {t('fastclick.description3')}
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <div className="flex flex-col rounded-[10px] bg-white px-4 py-3 ">
            <p className="font-bold text-[14px]">
              {t('fastclick.myPageAddress')}{' '}
              <a
                href={userInfo?.fastClickLink?.fastClickLink}
                target="_blank"
                rel="noreferrer"
                className="text-href text-[14px]"
              >
                {userInfo?.fastClickLink?.fastClickLink}
              </a>
            </p>
            <p
              className="  flex  w-full font-bold cursor-pointer text-[14px] gap-2"
              onClick={() => {
                moveToUrl(userInfo?.fastClickLink?.fastClickLink)
              }}
            >
              <span>{t('fastclick.visitLinkBlocks')}</span>
              <span className="text-[#FF8800]">
                {' '}
                {userInfo?.userType !== UserType.USER
                  ? userInfo?.fastClickLink?.productCount.toLocaleString() ?? 0
                  : 0}
                {t('fastclick.items')} {`>`}
              </span>
            </p>
          </div>
          <div className="grid md:grid-cols-4 grid-cols-1 gap-y-2 gap-x-1">
            <button
              className="bg-[rgba(165,0,11,0.3)] text-white font-bold text-[14px] flex justify-center items-center h-[40px] rounded-[10px] gap-1"
              onClick={() => {
                moveToUrl('https://youtu.be/vWvoVyGzcDs?si=CEQWeWr_fM3yUmxl')
              }}
            >
              <HelpIcon />
              {t('fastclick.oneMinuteGuide')}
              <img src="assets/img/logo/youtube.png" alt="youtube" width={26} />
            </button>
            <button
              className="bg-[rgba(165,0,11,0.3)] text-white font-bold text-[14px] flex justify-center items-center h-[40px] rounded-[10px] gap-1"
              onClick={() => {
                moveToUrl('https://blog.fastseller.shop/fastclick_guide/')
              }}
            >
              <HelpIcon />
              {t('fastclick.blogGuide')}
            </button>
            <button
              className="bg-[rgba(165,0,11,0.3)] text-white font-bold text-[14px] flex justify-center items-center h-[40px] rounded-[10px] gap-1"
              onClick={() => {
                moveToUrl(userInfo?.fastClickLink?.fastClickLink)
              }}
            >
              <ExternalIcon stroke="red" /> {t('fastclick.visitPage')}
            </button>
            <button
              className="bg-[rgba(165,0,11,0.3)] text-white font-bold text-[14px] flex justify-center items-center h-[40px] rounded-[10px] gap-1"
              onClick={() => {
                handleCopyClipBoard(userInfo?.fastClickLink?.fastClickLink)
              }}
            >
              <CopyIcon className="text-white" />
              {t('fastclick.copyAddress')}
            </button>
          </div>
          <div className="bg-[#2E343D] p-2 rounded-[10px]">
            <ul className=" list-disc text-white text-[14px] ml-4">
              <li>
                {t('fastclick.notices.coupang')}
              </li>
              <li>
                {t('fastclick.notices.planDuration')}
              </li>
              <li>
                {t('fastclick.notices.recovery')}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}
